"use client";

import React from "react";

type ServiceItem = {
  id: number;
  title: string;
  description?: string;
  link?: string;
  iconClass: string;
};

const services: ServiceItem[] = [
  {
    id: 1,
    title: "Opening Hours",
    description: "Monday - Thursday : 8:30 AM - 5:00 PM \nFriday: 8:30 AM - 1:00 PM ",
    iconClass: "fa-regular fa-clock",
  },
  {
    id: 2,
    title: "Address",
    description: "211 Walkers Road, George Town,\nCayman Island. KY1-1106",
    link: "https://maps.app.goo.gl/ceVfevcixMoUXG398",
    iconClass: "fa-solid fa-location-dot",
  },
  {
    id: 3,
    title: "Phone",
    // link: "tel:+13456402630",
    description: "+1 (345) 640-2630",
    iconClass: "fa-solid fa-phone",
  },
];

/* ================= COMPONENT ================= */

const ServiceArea: React.FC = () => {
  return (
    <section className="service-area" aria-label="Service Information">
      <div className="container">
        <div className="row">
          {services.map((service) => (
            <div className="col-lg-4 col-sm-6" key={service.id}>
              <div
                className={`single-service text-center ${service.id === 3 ? "sst-10" : ""
                  }`}
              >
                <div className="service-icon" aria-hidden="true">
                  <i className={service.iconClass} />
                </div>

                <div className="service-content">
                  <h2>{service.title}</h2>

                  {service.link ? (
                    <a
                      href={service.link}
                      aria-label={service.title}
                      target={service.link.startsWith("http") ? "_blank" : undefined}
                      rel={service.link.startsWith("http") ? "noopener noreferrer" : undefined}
                    >
                      {service.description?.split("\n").map((line, idx) => (
                        <React.Fragment key={idx}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </a>
                  ) : (
                    <p>
                      {service.description?.split("\n").map((line, idx) => (
                        <React.Fragment key={idx}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
